import { styled } from "@mui/material";
import { EXPENSE_REPORT_STATUS } from "../../../../../../utils/constants/constants";

export const StatusText = styled("p", {
  shouldForwardProp: (prop) => prop !== "status",
})<{ status?: string }>(({ status, theme }) => ({
  width: "min-content",
  textAlign: "center",
  ...(status === EXPENSE_REPORT_STATUS.approved.id && {
    color: "#1C6428",
  }),
  ...(status === EXPENSE_REPORT_STATUS.paid.id && {
    color: "#097452",
  }),
  ...(status === EXPENSE_REPORT_STATUS.rejected.id && {
    color: theme.palette.error.main,
  }),
  ...(status === EXPENSE_REPORT_STATUS.submitted.id && {
    color: theme.palette.primary.main,
  }),
  ...(status === EXPENSE_REPORT_STATUS.returned_to_employee.id && {
    color: "#6F19DD",
  }),
}));
